import React from 'react'
import Button from './Button'
import constants from '../containers/Constants'
import styled, {keyframes} from 'styled-components'
import {tooltips} from "../constants"
import {connect} from 'react-redux'
import buttonSelectorImg from '../images/buttonSelector.png'
const StyledButtonSelector = styled.div
`
    float:left;
    width:80%;
    text-align:center;
    background: linear-gradient(to bottom, #29292d 0%,#29293d 100%);
    height:35vh;
    overflow-y:hidden;
    position:relative;
    border-bottom:3px solid #333;
`
const breathingBG = keyframes`
from{
    background:rgba(255,0,0,0);
}
to{
    background:rgba(255,0,0,.1);
}
`
const ButtonContainer = styled.ul
`
position:absolute;
top:-1.8vh;
left:50%;
transform:translate(-50%);
z-index:10;
display:block;
height:38.6vh;
width:54vh;
text-align:center;
li{
    list-style-type:none;
    height:33.333333%;
    width:25%;
    float:left;

    button{

        top:50%;
        transform:translateY(-50%);
        position:relative;
        width:40px;
        height:40px;

        animation: ${breathingBG} 2s ease-in-out alternate infinite;

        border:none;
        cursor:pointer;
        transition:.3s all;
        border-radius:50% 50%;

        &:hover{
            animation:none;
            background:rgba(255,0,0,.5);
            width:50px;
            height:50px;
            border:1px dotted rgba(255,0,0,.3);
        }
    }

    &.selected{
        button{
            animation:none;
            width:50px;
            height:50px;
           background:rgba(255,0,0,.5);
        }
    }
}
`


const ButtonSelectorImg = styled.img
`
    height:90%;
    left:50%;
    transform:translateX(-50%);
    position:absolute;
    bottom:5%;
`
const PresetIndicator = styled.h2
`
    font-size:1.75vh;
    position:absolute;
    height:58.4%;
    bottom:5%;
    font-family:"Segment7";
    z-index:3;
    left:50%;
    transform:translateX(-50%);
    line-height:0;
    width:4.2vh;
    text-align:right;
    color:red;
`
const ButtonSelector = ({curButton, preset}) => {

    var buttons = [];
    for(var i=0; i < constants.num_buttons; i++){
        if(i == curButton){
            buttons.push(<li key={i} className="selected"><Button key={i} data-tip={tooltips.ButtonSelector} buttonID={i} /></li>)
        } else{
            buttons.push(<li key={i} ><Button key={i} data-tip={tooltips.ButtonSelector} buttonID={i} /></li>)
        }
    }

    return (
        <StyledButtonSelector>
            <ButtonSelectorImg src={buttonSelectorImg} alt=""/>
            <PresetIndicator>{preset}</PresetIndicator>
        <ButtonContainer className="buttonSelector">
            {buttons}
        </ButtonContainer>
        </StyledButtonSelector>
    );

}

function mapStateToProps(state){
    return{
        curButton : state.buttons,
        preset : state.preset
    }
}
export default connect(mapStateToProps)(ButtonSelector)